import { Select } from 'antd';
import { classNames } from 'src/utilities';
import { useEffect, useState } from 'react';

export const SelectHover = ({
  disabled,
  placeholder,
  options,
  onChange,
  id,
  inputClassName,
  popupClassName,
  name,
  value,
  filterOption,
  mode = null,
  dropdownStyle = {},
  dropdownId, // New prop for dropdown id
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Handle body scroll prevention on mobile when dropdown is open
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    if (isMobile && isDropdownOpen) {
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else if (isMobile && !isDropdownOpen) {
      // Restore body scroll
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    // Cleanup function
    return () => {
      if (isMobile) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
    };
  }, [isDropdownOpen]);

  return (
    <div className="w-full">
      <Select
        id={id}
        name={name}
        disabled={disabled}
        style={{ WebkitTextFillColor: '#000' }}
        bordered={false}
        placeholder={placeholder}
        className={classNames(
          'border-none bg-white rounded-xl py-1  outline-none w-full',
          inputClassName ? inputClassName : ''
        )}
        options={options.map((option) => ({
          ...option,
          id: 'optionsIds',
        }))}
        popupClassName={classNames(
          'font-sans',
          // Mobile-specific styling to prevent page scroll
          'mobile-select-dropdown',
          popupClassName ? popupClassName : ''
        )}
        onChange={onChange ? onChange : () => null}
        value={value}
        showSearch
        filterOption={filterOption}
        mode={mode}
        dropdownRender={(menu) => <div id={dropdownId}>{menu}</div>}
        // Mobile-specific props
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        dropdownStyle={dropdownStyle}
        onDropdownVisibleChange={(open) => setIsDropdownOpen(open)}
      />
    </div>
  );
};
